var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg095User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.57 11.67C17.3226 10.1746 17.9574 7.74531 17.1605 5.58365C16.3636 3.42199 14.3039 1.98608 12 1.98608C9.69613 1.98608 7.6364 3.42199 6.8395 5.58365C6.0426 7.74531 6.67742 10.1746 8.43 11.67C4.56147 13.1485 2.00457 16.8586 2 21C2 21.5523 2.44772 22 3 22C3.55228 22 4 21.5523 4 21C4 16.5817 7.58172 13 12 13C16.4183 13 20 16.5817 20 21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21C21.9954 16.8586 19.4385 13.1485 15.57 11.67ZM12 11C10.067 11 8.5 9.43299 8.5 7.49999C8.5 5.567 10.067 3.99999 12 3.99999C13.933 3.99999 15.5 5.567 15.5 7.49999C15.5 9.43299 13.933 11 12 11Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg095User);
export default __webpack_public_path__ + "static/media/095-user.6653bdd25937115c38db4bccd84ba994.svg";
export { ForwardRef as ReactComponent };